import React from 'react';
import SelectSmall from '../../../general-components/select-small';
import { SelectGroupOption } from '../../../general-components/select-group';
import { AppSettings } from '../../../../stores/reducers/settings';

const options: SelectGroupOption[] = [
	{ label: 'None', value: 0 },
	{ label: 'Small', value: 4 },
	{ label: 'Medium', value: 16 },
	{ label: 'Large', value: 32 },
	{ label: 'X-Large', value: 64 },
	{ label: 'Pillbox', value: 999 },
];

interface Props {
	queue: AppSettings;
	settingsForShotEdited: (newQueue: any) => void;
}

export default function VideoRadius(props: Props) {
	const { 
		queue,
		settingsForShotEdited,
	} = props;

	function changePresenterVideoRadius(videoRadius: number) {
		const newQueue = { ...queue, presenterVideoRadius: videoRadius };
		settingsForShotEdited(newQueue);
	}

	return (
		<div className='settings-container presenter-video-radius-container'>
			<label className="subsection-title">Video Corner Rounding</label>
			<div className={'border-radius-options'}>
				<SelectSmall
					options={options}
					onChange={changePresenterVideoRadius}
					label={options[0].label}
					selected={options.find(
						(option) => option.value === queue.presenterVideoRadius,
					) || options[0]}
					dropdown={true}
					dropdownPosition={'drop-left'}
					forceOpenUp={true}
				/>
			</div>
		</div>
	);
}
